{
  "jsm-project-summary-onboarding.changeLayout": [
    {
      "type": 0,
      "value": "Change the layout and order of charts"
    }
  ],
  "jsm-project-summary-onboarding.closeButton": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jsm-project-summary-onboarding.description": [
    {
      "type": 0,
      "value": "You can now edit the summary page to keep your team up to date. Tailor your space overview by customizing the layout, filters, and charts."
    }
  ],
  "jsm-project-summary-onboarding.editFilters": [
    {
      "type": 0,
      "value": "Edit filters"
    }
  ],
  "jsm-project-summary-onboarding.heading": [
    {
      "type": 0,
      "value": "Edit your space summary"
    }
  ],
  "jsm-project-summary-onboarding.hideAddCharts": [
    {
      "type": 0,
      "value": "Hide or add charts"
    }
  ],
  "jsm-project-summary-onboarding.moreAboutFeature": [
    {
      "type": 0,
      "value": "More about space summary"
    }
  ],
  "jsm-project-summary-onboarding.okButton": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "jsm-project-summary-onboarding.whatsNewTitle": [
    {
      "type": 0,
      "value": "What’s new?"
    }
  ]
}